<form [formGroup]="form">
    <ion-text color="primary" class="ion-text-center">
        <h1>Sign up</h1>
    </ion-text>

    <ion-list class="ion-padding">

        <!-- First name -->
        <ion-item>
            <ion-input labelPlacement="floating" autocapitalize="true" formControlName="first_name" name="FirstName">
                <div slot="label">First Name <ion-text color="danger">*</ion-text></div>
            </ion-input>
        </ion-item>

        <!-- First name -->
        <ion-item>
            <ion-input labelPlacement="floating" autocapitalize="true" formControlName="last_name" name="LastName">
                <div slot="label">Last Name <ion-text color="danger">*</ion-text></div>
            </ion-input>
        </ion-item>

        <!-- Phone -->
        <ion-row>
            <ion-col size="4">
                <ion-item (click)="getCountryCode()">
                    <ion-input labelPlacement="floating" readonly type="tel" formControlName="country_code" name="Country code">
                        <div slot="label">Country <ion-text color="danger">*</ion-text></div>
                    </ion-input>
                    <ion-icon class="caret-down-outline" slot="end" name="caret-down-outline"></ion-icon>
                </ion-item>
            </ion-col>
            <ion-col size="8">
                <ion-item>
                    <ion-input labelPlacement="floating" type="number" inputmode="numeric" formControlName="phone" name="Phone">
                        <div slot="label">Area code + Phone <ion-text color="danger">*</ion-text></div>
                    </ion-input>
                </ion-item>
            </ion-col>

        </ion-row>

        <ion-item>
            <ion-input labelPlacement="floating" formControlName="password" name="Password" type="password">
                <div slot="label">Password <ion-text color="danger">*</ion-text></div>
            </ion-input>
        </ion-item>

        <div style="height: 10px"></div>

        <re-captcha *ngIf="useVisibleCaptcha"
            (resolved)="captchaResolved($event)" 
            [siteKey]="visibleRecaptchaKey">
        </re-captcha>

        <ion-button type="submit" expand="block" color="primary" (click)="signup()" [disabled]="isLoading || (!visibleCaptchaToken && useVisibleCaptcha)">
            <span *ngIf="!isLoading">
                <ion-icon class="ion-padding-end"></ion-icon>Sign up
            </span>
            <ion-spinner *ngIf="isLoading" name="circular"></ion-spinner>
        </ion-button>
        
        
        <div style="height: 10px"></div>

        <ion-note>By continuing, you agree iOnCourt's <a (click)="openTermsAndConditions()">Terms and Conditions</a> and acknowledge it's <a (click)="openPrivacyPolicy()">Privacy Policy</a></ion-note>

        <div style="height: 5px"></div>

        <ion-note>
            This site is protected by reCAPTCHA and the Google
            <a style="text-decoration: none;" href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a style="text-decoration: none;" href="https://policies.google.com/terms">Terms of Service</a> apply.
        </ion-note>
        
        <div style="height: 10px"></div>

    </ion-list>

</form>